//
//
//
//
//
//

import Security from "./mixins/Security";
export default {
  meta: {
    meta: {
      description: {
        name: 'description',
        content: 'Carehood'
      },
      keywords: {
        name: 'keywords',
        content: 'disabilities,community,disability,NDIS'
      },
      equiv: {
        'http-equiv': 'Content-Type',
        content: 'text/html; charset=UTF-8'
      }
    }
  },
  mixins: [Security],
  components: {},
  mounted: function mounted() {
    // dark mode
    this.$q.dark.set(this.$q.localStorage.getItem('darkMode'));
    /**
    // channels
    this.$socket.$subscribe('hook', data => {
      if (data.emit) {
        // new version
        if (data.emit === 'newVersion') {
          if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
              for (let registration of registrations) {
                registration.update()
              }
            })
          }
          setTimeout(() => {
            this.$q.notify({
              icon: 'warning',
              message:
                'A new version of the system has been deployed.<br/>Click refresh below to ensure you have the most up to date version of the system.',
              html: true,
              color: 'primary',
              multiLine: true,
              timeout: 0,
              actions: [
                {
                  label: 'Refresh Now',
                  color: 'white',
                  handler: () => {
                    window.location.reload(true)
                  }
                }
              ]
            })
          }, 5000)
        } else {
          this.$root.$emit(data.emit, data)
        }
      }
    })
    // user channel
    this.$socket.$subscribe(`user`, data => {
      if (data.user_id === this.user.id) {
        this.$root.$emit(data.emit, data)
      }
    })
     */
  }
};